import React, { Component } from 'react';
import './MarketplaceTemplate.css';
import CanvasPreview from '../ProjectCanvas/Canvas/CanvasPreview';

class MarketplaceTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      download: false,
      reactFlowInstance: null,
    };
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: 'var(--mui-palette-background-paper)',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <CanvasPreview className={'embed-tag'} />
      </div>
    );
  }
}
export default MarketplaceTemplate;
